<!-- * AUTH LAYOUT -->
<router-outlet></router-outlet>

<!-- * Message -->
<p-toast position="bottom-right" key="br"></p-toast>

<!-- * Message -->
<p-toast position="bottom-right" key="br-error"></p-toast>
